import { createSelector } from 'reselect'

const getPreferences = ({ preferences }) => preferences

const preferencesSelectors = {
  getPreferences: createSelector([getPreferences], (preferences) => preferences),
  getPreferenceByKey: (key) =>
    createSelector([getPreferences], (preferences) => {
      return preferences[key]
    }),
}

export default preferencesSelectors
